import { Component } from '@angular/core';

@Component({
  selector: 'app-layout',
  templateUrl: './auth.component.html'
})
export class AuthComponent {} 



// WEBPACK FOOTER //
// /home/estandar/web/tuhogaronline.tk/public_html/adminTHO/src/app/components/auth/auth.component.ts